import { idFormat, type ID } from "@redotech/redo-ids-cockroach";

export type ShopperAgentStrategyId = ID<"shopperAgentStrategy">;
export const shopperAgentStrategyIdFormat = idFormat<ShopperAgentStrategyId>({
  prefix: "sst_",
});

export type ShopperAgentStrategyOfferingId = ID<"shopperAgentStrategyOffering">;
export const shopperAgentStrategyOfferingIdFormat =
  idFormat<ShopperAgentStrategyOfferingId>({ prefix: "sso_" });
